// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// import Swiper styles
import 'swiper/css';

const Sliders = {
	init: () => {
		Sliders.initCarouselSimple();
		Sliders.initCarouselHomepage();
	},

	initCarouselSimple: () => {
		const simpleCarousels = document.querySelectorAll('.js-carousel');
		if (!simpleCarousels.length) return;

		const slider = new Swiper('.js-carousel', {
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
		});
	},

	initCarouselHomepage: () => {
		const carousel = document.querySelector('.js-carousel-homepage');
		if (!carousel) return;

		// Infinite loop ne fonctionne pas quand trop peu de slides, donc fix:
		const wrapper = carousel.querySelector('.swiper-wrapper');
		const originalSlides = [...wrapper.querySelectorAll('.swiper-slide')];
		const realCount = originalSlides.length;
		const minSlides = 6; // seuil mini loop + loopAdditionalSlides = 2

		// Si moins de 6, on duplique les slides
		while (wrapper.querySelectorAll('.swiper-slide').length < minSlides) {
			originalSlides.forEach((slide) => {
				wrapper.appendChild(slide.cloneNode(true));
			});
		}

		const slider = new Swiper('.js-carousel-homepage', {
			modules: [Navigation, Pagination, Autoplay],
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: 20,

			loop: true,
			loopAdditionalSlides: 2,

			autoplay: {
				delay: 7000,
			},
			speed: 500,
			allowTouchMove: false,
			breakpoints: {
				1280: {
					spaceBetween: 32,
				},
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
				// Custom bullets count
				renderBullet(index, className) {
					if (index >= realCount) return '';
					return `<span class="${className}" data-index="${index}"></span>`;
				},
				dynamicBullets: false,
			},

			on: {
				slideChange(swiper) {
					const realIndex = swiper.realIndex % realCount;
					const bullets = carousel.querySelectorAll('.swiper-pagination-bullet');
					bullets.forEach((b, i) => {
						b.classList.toggle('swiper-pagination-bullet-active', i === realIndex);
					});
				},
			},
		});
	},
};

export default Sliders;
